import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "specialist-box w-full flex pb-[2.4rem] border-b border-b-gray-100"
};
const _hoisted_2 = {
    class: "specialist-box__container group w-full grid tablet:grid-cols-[18rem_1fr_fit-content(20rem)] items-center gap-[2.4rem] tablet:gap-[4rem] relative cursor-pointer"
};
const _hoisted_3 = [
    "href"
];
const _hoisted_4 = {
    class: "specialist-box__image w-full flex"
};
const _hoisted_5 = [
    "src"
];
const _hoisted_6 = {
    class: "specialist-box__content w-full h-full flex flex-col justify-center"
};
const _hoisted_7 = {
    class: "specialist-box__name w-full"
};
const _hoisted_8 = [
    "innerHTML"
];
const _hoisted_9 = {
    class: "specialist-box__desc w-full mt-[.8rem]"
};
const _hoisted_10 = [
    "innerHTML"
];
const _hoisted_11 = {
    class: "specialist-box__tags w-full mt-[1.6rem]"
};
const _hoisted_12 = {
    class: "tags w-fit flex items-center gap-[1.6rem] flex-wrap"
};
const _hoisted_13 = [
    "innerHTML"
];
export default {
    __name: 'SpecialistBox',
    props: {
        specialist: {
            type: Object,
            default: {}
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", {
                        href: __props.specialist.link,
                        class: "absolute top-0 left-0 w-full h-full z-[1]",
                        "aria-label": "Novum"
                    }, null, 8, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                            src: __props.specialist._embedded['wp:featuredmedia'][0].media_details.sizes.medium_small.source_url,
                            width: "180",
                            height: "180",
                            loading: "lazy",
                            alt: "Novum",
                            class: "max-w-[10rem] h-[10rem] tablet:max-w-full tablet:h-[18rem]"
                        }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h3", {
                                class: "name display-sm tablet:group-hover:text-red",
                                innerHTML: __props.specialist.title.rendered
                            }, null, 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", {
                                class: "excerpt body-md",
                                innerHTML: __props.specialist.excerpt.rendered
                            }, null, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.specialist._embedded['wp:term'][0], (term)=>{
                                    return _openBlock(), _createElementBlock("div", {
                                        key: term.id,
                                        class: "tag__box px-[0.8rem] py-[0.4rem] bg-gray-100 rounded-[3rem] justify-center items-center"
                                    }, [
                                        _createElementVNode("p", {
                                            class: "tag body-sm font-medium",
                                            innerHTML: term.name
                                        }, null, 8, _hoisted_13)
                                    ]);
                                }), 128))
                            ])
                        ])
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("div", {
                        class: "specialist-box__button w-fit h-fit flex"
                    }, [
                        _createElementVNode("p", {
                            class: "tablet:hidden btn btn--link btn--icon",
                            "data-icon": "b"
                        }, "Otwórz profil"),
                        _createElementVNode("p", {
                            class: "only-mobile:hidden transition btn btn--primary no-change opacity-0 group-hover:opacity-100"
                        }, "Otwórz profil")
                    ], -1))
                ])
            ]);
        };
    }
};
